export const CONTRACTS = [
  { id: 1, name: "ERP Migration Project",   client: "Global Solutions Inc.", value: 45000, status: "Active",    startDate: "Jan 1, 2025",  endDate: "Dec 31, 2025" },
  { id: 2, name: "Custom Module Dev",        client: "Nexus Systems",         value: 12500, status: "Pending",   startDate: "Feb 15, 2025", endDate: "Aug 15, 2025" },
  { id: 3, name: "Annual Support Plan",      client: "TechFlow Co.",          value: 8000,  status: "Active",    startDate: "Mar 1, 2025",  endDate: "Feb 28, 2026" },
  { id: 4, name: "Inventory Optimization",   client: "Prime Retailers",       value: 22000, status: "Active",    startDate: "Apr 10, 2025", endDate: "Oct 10, 2025" },
  { id: 5, name: "API Integration Phase 2",  client: "StreamLine Logics",     value: 15000, status: "Cancelled", startDate: "May 1, 2025",  endDate: "Jul 31, 2025" },
];

export const TIMESHEETS = {
  1: [
    { id: 1, employee: "Alice Johnson", date: "Mar 10, 2025", hours: 8,   task: "Database schema design",  status: "Approved" },
    { id: 2, employee: "Bob Smith",     date: "Mar 11, 2025", hours: 6,   task: "API endpoint setup",      status: "Pending"  },
    { id: 3, employee: "Carol White",   date: "Mar 12, 2025", hours: 7.5, task: "Frontend integration",    status: "Approved" },
  ],
  2: [
    { id: 1, employee: "David Lee",    date: "Mar 8, 2025", hours: 5, task: "Module architecture",   status: "Approved" },
    { id: 2, employee: "Eva Martinez", date: "Mar 9, 2025", hours: 8, task: "Custom field mapping",  status: "Pending"  },
  ],
  3: [{ id: 1, employee: "Frank Chen", date: "Mar 5, 2025", hours: 4, task: "Server maintenance", status: "Approved" }],
  4: [
    { id: 1, employee: "Grace Kim",  date: "Mar 14, 2025", hours: 7, task: "Inventory audit",       status: "Approved" },
    { id: 2, employee: "Henry Park", date: "Mar 15, 2025", hours: 6, task: "Stock reconciliation",  status: "Pending"  },
  ],
  5: [],
};

export const TASKS = {
  1: [
    { id: 1, title: "Set up dev environment",    assignee: "Alice Johnson", due: "Mar 15, 2025", priority: "High",   status: "Done"        },
    { id: 2, title: "Database migration script", assignee: "Bob Smith",     due: "Mar 22, 2025", priority: "High",   status: "In Progress" },
    { id: 3, title: "QA testing phase 1",        assignee: "Carol White",   due: "Apr 5, 2025",  priority: "Medium", status: "To Do"       },
    { id: 4, title: "Security audit",            assignee: "Alice Johnson", due: "Apr 15, 2025", priority: "High",   status: "Hold"        },
  ],
  2: [
    { id: 1, title: "Requirement gathering", assignee: "David Lee",    due: "Mar 10, 2025", priority: "High",   status: "Done"        },
    { id: 2, title: "UI wireframes",         assignee: "Eva Martinez", due: "Mar 20, 2025", priority: "Medium", status: "In Progress" },
  ],
  3: [{ id: 1, title: "Monthly health check", assignee: "Frank Chen", due: "Apr 1, 2025", priority: "Low", status: "To Do" }],
  4: [
    { id: 1, title: "Data sync setup",   assignee: "Grace Kim",  due: "Apr 20, 2025", priority: "High",   status: "In Progress" },
    { id: 2, title: "Report generation", assignee: "Henry Park", due: "Apr 28, 2025", priority: "Medium", status: "To Do"       },
  ],
  5: [
  ],
};

export const PAYMENTS = [
  { id: 1, contract: "ERP Migration Project",  amount: 15000, date: "Feb 1, 2025",  method: "Bank Transfer", status: "Paid"    },
  { id: 2, contract: "ERP Migration Project",  amount: 15000, date: "Mar 1, 2025",  method: "Bank Transfer", status: "Paid"    },
  { id: 3, contract: "ERP Migration Project",  amount: 15000, date: "Apr 1, 2025",  method: "Bank Transfer", status: "Pending" },
  { id: 4, contract: "Custom Module Dev",      amount: 6250,  date: "Feb 15, 2025", method: "Credit Card",   status: "Paid"    },
  { id: 5, contract: "Custom Module Dev",      amount: 6250,  date: "Mar 15, 2025", method: "Credit Card",   status: "Pending" },
  { id: 6, contract: "Annual Support Plan",    amount: 8000,  date: "Jan 1, 2025",  method: "Bank Transfer", status: "Paid"    },
  { id: 7, contract: "Inventory Optimization", amount: 11000, date: "Apr 10, 2025", method: "Wire",          status: "Pending" },
  { id: 8, contract: "Inventory Optimization", amount: 11000, date: "May 10, 2025", method: "Wire",          status: "Pending" },
];

export const INVOICES = [
  { id: "INV-001", contract: "ERP Migration Project",  client: "Global Solutions Inc.", amount: 15000, date: "Feb 1, 2025",  due: "Feb 15, 2025", status: "Paid"      },
  { id: "INV-002", contract: "ERP Migration Project",  client: "Global Solutions Inc.", amount: 15000, date: "Mar 1, 2025",  due: "Mar 15, 2025", status: "Paid"      },
  { id: "INV-003", contract: "ERP Migration Project",  client: "Global Solutions Inc.", amount: 15000, date: "Apr 1, 2025",  due: "Apr 15, 2025", status: "Unpaid"    },
  { id: "INV-004", contract: "Custom Module Dev",      client: "Nexus Systems",         amount: 6250,  date: "Feb 15, 2025", due: "Feb 28, 2025", status: "Paid"      },
  { id: "INV-005", contract: "Custom Module Dev",      client: "Nexus Systems",         amount: 6250,  date: "Mar 15, 2025", due: "Mar 31, 2025", status: "Overdue"   },
  { id: "INV-006", contract: "Annual Support Plan",    client: "TechFlow Co.",          amount: 8000,  date: "Jan 1, 2025",  due: "Jan 15, 2025", status: "Paid"      },
  { id: "INV-007", contract: "Inventory Optimization", client: "Prime Retailers",       amount: 11000, date: "Apr 10, 2025", due: "Apr 25, 2025", status: "Unpaid"    },
  { id: "INV-008", contract: "API Integration Phase 2",client: "StreamLine Logics",     amount: 15000, date: "May 1, 2025",  due: "May 15, 2025", status: "Overdue"   },
  { id: "INV-009", contract: "Web Platform Redesign",  client: "Global Tech",           amount: 4500,  date: "Mar 1, 2025",  due: "Mar 15, 2025", status: "Paid"      },
  { id: "INV-010", contract: "ERP Migration Project",  client: "TechCorp",              amount: 3200,  date: "Mar 5, 2025",  due: "Mar 20, 2025", status: "Unpaid"    },
  { id: "INV-011", contract: "Security Audit",         client: "Safety First Ltd",      amount: 1500,  date: "Mar 10, 2025", due: "Mar 25, 2025", status: "Overdue"   },
];

export const VALUE_RANGES = [
  { label: "All Values",  min: 0,     max: Infinity },
  { label: "Under $10K",  min: 0,     max: 9999 },
  { label: "$10K – $25K", min: 10000, max: 25000 },
  { label: "Above $25K",  min: 25001, max: Infinity },
];

export const CONTRACT_STATUSES  = ["All", "Active", "Pending", "Cancelled"];
export const TIMESHEET_STATUSES = ["All", "Approved", "Pending"];
export const TASK_STATUSES      = ["All", "To Do", "In Progress", "Done","Hold"];
export const PAYMENT_STATUSES   = ["All", "Paid", "Pending"];
export const INVOICE_STATUSES   = ["All", "Paid", "Unpaid", "Overdue"];

export function formatValue(n) { return "$" + n.toLocaleString(); }
